module.exports = __webpack_public_path__ + "44b298a9f6a6f93e1bdeca0d2ebb17b5.svg";